module.exports = __webpack_public_path__ + "static/media/contact-image.0298d3b8.jpg";